(() => {
  const hosts = new Set([location.hostname, 'downunderthunder.com.au', 'www.downunderthunder.com.au', 'downunderthunderr.myshopify.com']);
  const selector = 'a[href*="/collections/in-stock"]';
  function update(link) {
    try {
      const url = new URL(link.getAttribute('href'), location.href);
      if (!hosts.has(url.hostname) || !['http:', 'https:'].includes(url.protocol)) return;
      const match = url.pathname.match(/^(.*\/collections)\/in-stock(?:\/[^/]+)?\/?$/);
      if (!match) return;
      url.pathname = match[1];
      link.setAttribute('href', url.pathname + url.search + url.hash);
    } catch (_) {}
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.(selector)) update(root);
    root.querySelectorAll(selector).forEach(update);
  }
  scan(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') update(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
})();
